import service from '@/utils/request'

export function getPreparePage(params) {
  return service.get('/uic-system/api/prepare/page', {
    params
  })
}

export function getPrepareDetail(id) {
  return service.get('/uic-system/api_hf/prepare/detail', {
    params: { id }
  })
}

export function submitPrepare(data) {
  return service.post('/uic-system/api_hf/prepare', data)
}

// 备料库位校验-扫码成功提交
export function wareLocationScanSuccess(data) {
  return service.post('/uic-system_hf/wareoutdetailrecord/scanSuccess', data)
}
